import React from 'react'

import { formatMoney } from '@/shared/functions/String/string.functions'
import { Box, Typography } from '@mui/material'

import Accordion from '../../../Accordion/Accordion.component'
import ResponsiveDisplayWrapper from '../../../ResponsiveDisplayWrapper/ResponsiveDisplayWrapper.component'

import styles from './OverviewBreakdownSection.styles'
import { OverviewBreakdownSectionProps } from './OverviewBreakdownSection.types'

const OverviewBreakdownSection: React.FC<OverviewBreakdownSectionProps> = (props) => {
  const { subtotal, currency, totalItems, total, mobileAccordionBody, mobileButton, fulfillmentOrderPackageDetails } =
    props

  const getOverViewSubtotal = () => {
    if (subtotal === undefined || subtotal === null) return null

    return (
      <Box sx={styles.row}>
        <Typography sx={[styles.fieldText, styles.totalText]}>
          {totalItems} item{totalItems > 1 ? 's' : ''}
        </Typography>
        <Typography sx={styles.fieldText}>{formatMoney(subtotal, currency)}</Typography>
      </Box>
    )
  }

  const getPackageStats = () => {
    if (!fulfillmentOrderPackageDetails) return null

    return (
      <Box sx={styles.packageStatsSection}>
        <Box sx={styles.packageStatRow}>
          <Typography sx={styles.packageStatLabel}>Total Items</Typography>
          <Typography sx={styles.packageStatValue}>{fulfillmentOrderPackageDetails.totalItems}</Typography>
        </Box>

        {fulfillmentOrderPackageDetails.totalWeightGrams !== undefined &&
          fulfillmentOrderPackageDetails.totalWeightGrams > 0 && (
            <Box sx={styles.packageStatRow}>
              <Typography sx={styles.packageStatLabel}>Total Weight</Typography>

              <Typography sx={styles.packageStatValue}>
                {fulfillmentOrderPackageDetails.totalWeightGrams.toLocaleString()} g
              </Typography>
            </Box>
          )}

        {fulfillmentOrderPackageDetails.lengthCm !== undefined && fulfillmentOrderPackageDetails.lengthCm > 0 && (
          <Box sx={styles.packageStatRow}>
            <Typography sx={styles.packageStatLabel}>Package Size</Typography>
            <Typography sx={styles.packageStatValue}>
              {fulfillmentOrderPackageDetails.lengthCm} x {fulfillmentOrderPackageDetails.widthCm} x{' '}
              {fulfillmentOrderPackageDetails.heightCm} cm
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  return (
    <>
      {/* Desktop: Subtotal label row */}
      <ResponsiveDisplayWrapper isDesktop={true}>
        <Box sx={styles.subTotalRow}>
          <Typography variant="subtitle1" sx={styles.subtotalTitleText}>
            Subtotal
          </Typography>
        </Box>
      </ResponsiveDisplayWrapper>

      {/* Mobile: Subtotal + total grouped left, button centered right */}
      <ResponsiveDisplayWrapper isDesktop={false}>
        <Box sx={styles.mobileRow}>
          <Box sx={styles.mobileLeftContent}>
            <Box sx={styles.accordionWrapper}>
              <Accordion
                expandIconPosition="right"
                header={{
                  mainContent: (
                    <Typography variant="subtitle1" sx={styles.subtotalTitleText}>
                      {total ? 'Amount To Pay' : 'Subtotal'}
                    </Typography>
                  )
                }}
                body={
                  <>
                    {getPackageStats()}
                    {getOverViewSubtotal()}
                    {mobileAccordionBody}
                  </>
                }
              />
            </Box>

            <Typography sx={styles.totalValueText}>{formatMoney(total ?? subtotal, currency)}</Typography>
          </Box>

          {mobileButton && <Box sx={styles.mobileButtonWrapper}>{mobileButton}</Box>}
        </Box>
      </ResponsiveDisplayWrapper>

      {/* Desktop: Subtotal rows */}
      <ResponsiveDisplayWrapper isDesktop>{getOverViewSubtotal()}</ResponsiveDisplayWrapper>
    </>
  )
}

export default OverviewBreakdownSection
